if (!customElements.get('leo-manual-reviews-carousel')) {
  class LeoManualReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-leo-reviews-track]');
      this.prevButton = this.querySelector('[data-leo-reviews-prev]');
      this.nextButton = this.querySelector('[data-leo-reviews-next]');
      this.currentEl = this.querySelector('[data-leo-reviews-current]');
      this.totalEl = this.querySelector('[data-leo-reviews-total]');

      if (!this.track) return;

      this.prevButton?.addEventListener('click', () => this.scroll(-1));
      this.nextButton?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());

      this.update();
    }

    getStep() {
      const firstCard = this.track.querySelector('.leo-manual-reviews-carousel__slide');
      if (!firstCard) return this.track.clientWidth;

      const styles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
      return firstCard.getBoundingClientRect().width + gap;
    }

    getTotalPages() {
      const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      if (maxScroll === 0) return 1;
      return Math.ceil(maxScroll / this.getStep()) + 1;
    }

    scroll(direction) {
      this.track.scrollBy({
        left: this.getStep() * direction,
        behavior: 'smooth',
      });
    }

    update() {
      const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const total = this.getTotalPages();
      const current = maxScroll === 0 ? 1 : Math.min(Math.round(this.track.scrollLeft / this.getStep()) + 1, total);

      if (this.currentEl) this.currentEl.textContent = current;
      if (this.totalEl) this.totalEl.textContent = total;
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('leo-manual-reviews-carousel', LeoManualReviewsCarousel);
}
